<script lang="ts">
  export let on_click: Function;
  export let clickable: boolean;
  export let highlight: boolean;
</script>

<div
  on:click={() => {
    clickable && on_click();
  }}
  class={`cell ${highlight ? "highlight" : "reg"} ` + $$props.class}
  style={`cursor: ${clickable ? "pointer" : "default"}`}
>
  <slot><div /></slot>
</div>

<style>
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: var(--accent-color);
    border-radius: 5px;
    margin: 2px;
    font-size: 2rem;
    transition: all 100ms;
    user-select: none;
    overflow: hidden;
  }

  .reg {
    box-shadow: var(--accent-color-shadow) 0px 4px 0px;

    /* box-shadow: 0px 0px 10px 2px var(--accent-color-shadow); */
  }

  .highlight {
    box-shadow: 0px 0px 10px 2px rgb(255, 221, 142);
  }

  .cell:hover {
    background-color: var(--accent-color-hover);
  }

  .cell:active {
    background-color: var(--accent-color-active);
  }

  .filled{
      /* --accent-color-shadow: #938a8a; */
      animation: pulse 0.2s linear 1;
      font-weight: 600;
  }

  .filled-invalid , .filled-wrong{
      --accent-color-shadow: #938a8a;
      animation: pulse 0.2s linear 1;
      font-weight: 600;
  }

  .filled-invalid{
    animation: shake 0.2s linear 1;
  }

  .filled-close{
      --accent-color-shadow: #f3bd29;
      animation: pulse 0.2s linear 1;
      font-weight: 600;
  }
  .filled-correct{
      --accent-color-shadow: var(--special-color);
      animation: pulse 0.2s linear 1;
      font-weight: 600;
  }

  @keyframes push{
  50%  {transform: scale(0.8);}
  }
  @keyframes pulse{
  25%  {transform: scale(0.9);}
  75%  {transform: scale(1.1);}
}

  @keyframes shake {
    0% { transform: translate(1px, 1px) rotate(0deg); }
    10% { transform: translate(-1px, -2px) rotate(-1deg); }
    20% { transform: translate(-3px, 0px) rotate(1deg); }
    30% { transform: translate(3px, 2px) rotate(0deg);   --accent-color-shadow: #fac1bb;}
    40% { transform: translate(1px, -1px) rotate(1deg);  --accent-color-shadow: #f89990;}
    50% { transform: translate(-1px, 2px) rotate(-1deg); --accent-color-shadow: #ff6253;}
    60% { transform: translate(-3px, 1px) rotate(0deg);  --accent-color-shadow: #ff412f;}
    70% { transform: translate(3px, 1px) rotate(-1deg);  --accent-color-shadow: #ca3022;}
    80% { transform: translate(-1px, -1px) rotate(1deg); }
    90% { transform: translate(1px, 2px) rotate(0deg); }
    100% { transform: translate(1px, -2px) rotate(-1deg); }
  }
</style>
